module.exports = __webpack_public_path__ + "static/media/21868_1356209472012_2503812_n.77757c72.jpg";